import { render, staticRenderFns } from "./bac.vue?vue&type=template&id=ebde9624&"
import script from "./bac.vue?vue&type=script&lang=js&"
export * from "./bac.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports